import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const leadSchema = z.object({
  name: z.string().trim().min(2).max(100),
  company: z.string().trim().min(2).max(120),
  role: z.string().trim().min(2).max(100),
  whatsapp: z.string().trim().min(8).max(30),
  email: z.string().trim().email().max(255),
  companyUrl: z.string().trim().min(2).max(240),
  acquisitionChannels: z.array(z.enum([
    "Indicação",
    "Instagram",
    "Google",
    "Tráfego pago",
    "Prospecção comercial",
    "Eventos e feiras",
    "Parceiros",
    "Outros",
  ])).min(1).max(8),
  growthChallenge: z.string().trim().min(10).max(1500),
  paidTrafficExperience: z.enum(["Sim, atualmente", "Já investi, mas parei", "Nunca investi"]),
  commercialOwner: z.enum(["Sim", "Não", "Estamos estruturando"]),
  utmSource: z.string().trim().max(120).optional(),
  utmMedium: z.string().trim().max(120).optional(),
  utmCampaign: z.string().trim().max(120).optional(),
  utmContent: z.string().trim().max(120).optional(),
  utmTerm: z.string().trim().max(120).optional(),
});

export const submitGrowthDiagnostic = createServerFn({ method: "POST" })
  .inputValidator((input) => leadSchema.parse(input))
  .handler(async ({ data }) => {
    const { getServerSupabase } = await import("./supabase.server");
    const supabase = getServerSupabase();

    const utmSource = data.utmSource || "feira";
    const utmMedium = data.utmMedium || "qrcode";
    const utmCampaign = data.utmCampaign || "construcao_bc";
    const utmContent = data.utmContent ?? null;
    const utmTerm = data.utmTerm ?? null;

    const { error } = await supabase.from("growth_diagnostic_leads").insert({
      name: data.name,
      company: data.company,
      role: data.role,
      whatsapp: data.whatsapp,
      email: data.email,
      company_url: data.companyUrl,
      acquisition_channels: data.acquisitionChannels,
      growth_challenge: data.growthChallenge,
      paid_traffic_experience: data.paidTrafficExperience,
      commercial_owner: data.commercialOwner,
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      utm_content: utmContent,
      utm_term: utmTerm,
      landing_page: "/construirai",
      status: "new",
    });

    if (error) throw new Error("Não foi possível registrar a solicitação.");

    return { success: true };
  });